import { Component, type ReactNode } from "react";

/**
 * Barreira de erro de render: um crash em qualquer componente filho (ex.:
 * markdown/mermaid de uma resposta parcial) NÃO pode derrubar a área inteira
 * do chat em tela branca - o job continua no servidor e a pessoa precisa de
 * feedback e de um caminho de recuperação.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error): { error: Error } {
    return { error };
  }

  componentDidCatch(error: Error): void {
    console.error("[render] erro capturado pela ErrorBoundary:", error);
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="render-crash" role="alert">
          <strong>Algo deu errado ao exibir esta conversa.</strong>
          <p>O conteúdo continua salvo e a resposta segue sendo processada no servidor.</p>
          <div className="render-crash-actions">
            <button type="button" className="btn-approve" onClick={() => this.setState({ error: null })}>
              Tentar exibir de novo
            </button>
            <button type="button" className="btn-reject" onClick={() => window.location.reload()}>
              Recarregar a página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
